import { app } from '../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.manage-user.details', {
        url: '/details',
        component: 'companyUserDirectoriesManageUserDetails',
    });
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-user/details/manage-user-details.state.js